export default __webpack_public_path__ + "static/logo-jornadas-c2f7a0d3a7b076615d01f6ee5f38e27b.png";